import { render, staticRenderFns } from "./ProfileTransactions.vue?vue&type=template&id=43924f49&scoped=true"
import script from "./ProfileTransactions.vue?vue&type=script&lang=js"
export * from "./ProfileTransactions.vue?vue&type=script&lang=js"
import style0 from "./ProfileTransactions.vue?vue&type=style&index=0&id=43924f49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43924f49",
  null
  
)

export default component.exports